<span
  class="authenticated-header-wrapper registration-in-progress-wrapper"
  *ngIf="!registrationFinished"
>
  <ul class="nav align-items-center header-link-nav-bar">
    <li *ngIf="completeButtonVisible">
      <button
        type="button"
        class="btn-link me-1 me-md-2"
        (click)="navigateToStep3OfRegistration()"
        ngbDropdownItem
      >
        Complete set-up >
      </button>
    </li>
  </ul>
</span>
<span class="authenticated-header-wrapper">
  <ul
    *ngIf="!displayOnlyUserIconDropdown"
    class="nav align-items-center header-link-nav-bar"
  >
    <li class="nav-item ms-4">
      <a routerLink="/lost-and-found">Lost &amp; found</a>
    </li>
    <li class="nav-item mx-4">
      <a routerLink="/contact-us">Contact us</a>
    </li>
    <li class="nav-item me-4">
      <a routerLink="/identi-professionals">identi professionals</a>
    </li>
  </ul>
  <ul
    *ngIf="!displayOnlyUserIconDropdown"
    class="nav align-items-center header-icon-nav-toggle"
  >
    <li
      ngbDropdown
      display="dynamic"
      placement="bottom-right"
      class="nav-item"
      (openChange)="opened($event)"
    >
      <a ngbDropdownToggle class="nav-info nav-link"> Information </a>
      <div ngbDropdownMenu>
        <div>
          <a ngbDropdownItem class="ms-3" routerLink="/microchipping-your-pet"
            >Microchipping</a
          >
          <a
            ngbDropdownItem
            class="ms-3"
            href="https://identicare.zendesk.com/hc/en-us"
            target="_blank"
            >Help Centre</a
          >
          <a
            ngbDropdownItem
            class="ms-3"
            href="https://identiblog.zendesk.com/hc/en-us"
            target="_blank"
            >Blog</a
          >
        </div>
      </div>
    </li>
  </ul>
  <ul
    *ngIf="!displayOnlyUserIconDropdown"
    class="nav align-items-center header-link-nav-bar"
  >
    <div class="nav-item-divider"></div>

    <li *ngIf="displayUserIconDropdown" class="nav-item">
      <a 
      routerLink="/dashboard"
      trackClickEvent
      [eventNumber]="ClickEventNumbersEnum.Dashboard" 
      class="fw-bold">
        Dashboard
      </a>
    </li>
    <li *ngIf="displayUserIconDropdown" class="nav-item mx-4">
      <a routerLink="/account">
        My account
      </a>
    </li>

    <li *ngIf="displayUserIconDropdown">
      <button
        type="button"
        class="btn-link"
        (click)="authManager.logout()"
        ngbDropdownItem
      >
        Log out
      </button>
    </li>

    <div class="nav-item-divider"></div>

    <li class="nav-item me-2">
      <a routerLink="/claim-pet" class="fw-bold"
        >Transfer of Keepership</a
      >
    </li>

    <li *ngIf="displayUserIconDropdown">
      <app-social-facebook
        [badgeWrapperSize]="'32px'"
        [badgeIconSize]="'20px'"
      ></app-social-facebook>
    </li>
    <li *ngIf="displayUserIconDropdown">
      <app-social-instagram
        [badgeWrapperSize]="'32px'"
        [badgeIconSize]="'20px'"
      ></app-social-instagram>
    </li>
    <li *ngIf="displayUserIconDropdown">
      <app-social-twitter
        [badgeWrapperSize]="'32px'"
        [badgeIconSize]="'20px'"
      ></app-social-twitter>
    </li>
  </ul>

  <ul
    *ngIf="!displayUserIconDropdown"
    class="nav align-items-center header-icon-nav-toggle"
  >
    <li
      ngbDropdown
      display="dynamic"
      placement="bottom-right"
      class="nav-item"
      (openChange)="opened($event)"
    >
      <a ngbDropdownToggle class="nav-avatar nav-link">
        <span *ngIf="pets.length" class="nav-avatar-circle">
          <span
            class="nav-avatar-img"
            [ngStyle]="{
              'background-image': pets[0].imageId
                ? 'url(' + getPetImageUrl(pets[0].imageId) + ')'
                : 'none'
            }"
          >
            <span *ngIf="!pets[0].imageId" class="fw-bold">
              {{ pets[0].name.trim().charAt(0) | uppercase }}
            </span>
          </span>
        </span>
        <span *ngIf="!pets.length" class="nav-avatar-circle">
          <span class="nav-avatar-img">
            <fa-icon [icon]="['fas', 'user']" [fixedWidth]="true"></fa-icon>
          </span>
        </span>
      </a>
      <div ngbDropdownMenu>
        <div>
          <a ngbDropdownItem routerLink="/dashboard">Dashboard</a>
          <a ngbDropdownItem routerLink="/account">My account</a>
          <button
            type="button"
            class="btn-link"
            (click)="authManager.logout()"
            ngbDropdownItem
          >
            Log out
          </button>
          <a ngbDropdownItem routerLink="/claim-pet">Transfer of Keepership</a>

          <span *ngIf="displayOnlyUserIconDropdown">
            <a ngbDropdownItem routerLink="/microchipping-your-pet"
              >Microchipping</a
            >
            <a ngbDropdownItem routerLink="/lost-and-found">Lost &amp; found</a>
            <a ngbDropdownItem routerLink="/contact-us">Contact us</a>
            <a ngbDropdownItem routerLink="/identi-professionals">identi professionals</a>
            <a
              ngbDropdownItem
              href="https://identicare.zendesk.com/hc/en-us"
              target="_blank"
              >Help Centre</a
            >
            <a
              ngbDropdownItem
              href="https://identiblog.zendesk.com/hc/en-us"
              target="_blank"
              >Blog</a
            >
          </span>

          <span class="social-icons-wrapper">
            <app-social-facebook
              [badgeWrapperSize]="'24px'"
              [badgeIconSize]="'16px'"
            ></app-social-facebook>
            <app-social-instagram
              [badgeWrapperSize]="'24px'"
              [badgeIconSize]="'16px'"
            ></app-social-instagram>
            <app-social-twitter
              [badgeWrapperSize]="'24px'"
              [badgeIconSize]="'16px'"
            ></app-social-twitter>
          </span>
        </div>
      </div>
    </li>
  </ul>
</span>
